import { useEffect, useState, useRef } from 'react';
import ReactContentEditable from 'react-contenteditable';
import style from './style.scss';
import cx from 'classnames';
/* eslint-disable react/prop-types */ // TODO: add props

const ContentEditable = ({
  onChange,
  readOnly,
  defaultValue,
  className,
  tagName = 'div',
  ...props
}) => {
  const contentEditable = useRef();
  const firstRender = useRef(true);
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    // this  prevents the first render from triggering the onChange
    // The content editable component seems to fire it on first render
    // so we're just ensuring that doesn't fire _our_ onChange
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      onChange(value);
    }
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (value !== defaultValue) {
      setValue(defaultValue);
    }
  }, [defaultValue]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ReactContentEditable
      className={cx(style.contentEditable, className)}
      innerRef={contentEditable}
      html={value}
      disabled={readOnly}
      onChange={(e) => {
        setValue(e.target.value);
      }}
      tagName={tagName}
      {...props}
    />
  );
};

export default ContentEditable;
